module.exports = __webpack_public_path__ + "img/facebook.181f3420.svg";